export function getEmptyFlowDefinition(editorV2Enabled: boolean) {
  return editorV2Enabled
    ? { flow_version: "v2" as const, nodes: [], edges: [] }
    : { nodes: [], edges: [] };
}

export function isEditorV2Enabled(
  settings: { editor_v2_enabled?: boolean } | null | undefined
): boolean {
  return Boolean(settings?.editor_v2_enabled);
}
